import axios from '../config/axiosConfig';
import { BASE_URL } from './constant/BaseApiUrl';

export default class ConvertQuoteBookingService {
  addBookingId(quoteId, payload) {
    return axios.post(`${BASE_URL}quotes/${quoteId}/add-bookingId`, payload);
  }
  updateBookingById(quoteId, payload) {
    return axios.put(`${BASE_URL}quotes/${quoteId}/add-bookingId`, payload);
  }
}
